<template>
<el-tree
    class="tree-w-stroke obj-tree"
    v-loading="rootLoading"
    :ref="treeRef"
    lazy
    :load="loadData"
    :props="defaultProps"
    :node-key="defaultProps.treeKey"
    :expand-on-click-node="false"
    highlight-current
    @node-click="onClickNode"
    :allow-drop="allowDrop"
  >
  <span class="el-tree-node__label" slot-scope="{ node, data }">
    <!-- obj -->
    <drag v-if="isObjNode(data)" :transfer-data="node" @dragstart="onDragObj" @dragend="onDragEnd" style="display: inline; line-height:19px; padding-left: 3px;">
      <!-- obj -->
      <el-tooltip v-if="isRequireIPObjType(data)" class="item" effect="dark" :content="getIpTooltipContent(data)" placement="right">
        <span>
          <span v-if="!isEmpty(data.subType)" class="obj-icon">
            <i :class="getObjTypeIconClass(data)"></i>
          </span>
          <span>{{ data.label }}</span>
        </span>
      </el-tooltip>
      <span v-else>
        <span v-if="!isEmpty(data.subType)" class="obj-icon">
          <i :class="getObjTypeIconClass(data)"></i>
        </span>
        <span>{{ data.label }}</span>
      </span>
    </drag>
    <!-- root, group -->
    <span v-else>
      <span class="group">{{ data.label }}</span>
    </span>
  </span>
  </span>
</el-tree>
</template>

<script>
import { isNil, isEmpty, assign, isArray } from 'lodash';
import { defaultProps, treeType } from '@/constants/tree';
import TreeApi from '@/api/common/tree';
import { isRequireIPObjType, getObjTypeIconClass, isObjNode, getIpTooltipContent, hasObjTypeIcon } from '@/utils/tree';
import { getValueAfterCheckEmpty } from '@/utils/string';
import MsgUtil from '@/utils/message';
import DynamicTreeMixin from '@/mixins/tree/dynamic-tree';
import DynamicTargetTreeMixin from '@/components/tree/TargetTree/mixins/dynamic-tree';
import DragTreeMixin from './mixins/drag-tree';

export default {
  name: 'WDynamicLogicalTree',
  mixins: [DynamicTreeMixin, DynamicTargetTreeMixin, DragTreeMixin],
  props: {
    treeTypes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      treeType: treeType.LOGICAL,
      treeRef: `${treeType.LOGICAL}Tree`,
      treeTypesInMenu: this.treeTypes,
      defaultProps,
    };
  },
  methods: {
    isEmpty,
    getValueAfterCheckEmpty,
    isObjNode,
    isRequireIPObjType,
    hasObjTypeIcon,
    getObjTypeIconClass,
    getIpTooltipContent,
    /**
     * 트리 노드 데이터를 조회한다.
     * @author Ju
     * @param  {Object} node    부모 노드 객체
     * @param  {Object} resolve
     */
    loadData(node, resolve) {
      if (node.level === 0 && this.loading === true) {
        return;
      }
      const params = assign(this.getBaseParams(node), { exceptDefineIds: ['SERVICE'] });
      this.loading = true;
      if (node.level === 0) {
        this.rootLoading = true;
      }
      TreeApi.getLogicalTreeData(params)
        .then((response) => {
          if (response.data.success) {
            const children = isArray(response.data.children) ? response.data.children : [response.data.children];
            resolve(children);
            if (!isEmpty(children)) {
              this.$nextTick(() => {
                const tree = this.$refs[this.treeRef];
                this.createChildNodes(children, tree);
                if (!isNil(this.searchKeyword) && this.searchKeyword !== '') {
                  this.setLoadedStatusToAllTreeNodes();
                }
              });
            }
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '논리 그룹 트리 정보', false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '논리 그룹 트리 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.rootLoading = false;
          this.loading = false;
        });
    },
    onClickNode(data, node) {
      if (!node.isLeaf) {
        node.expand();
      }
      this.$emit('clickNode', data, node);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/chart/components/tree/DynamicLogicalTree.vue